<template>
	<div class="form-wrapper">
		<b-row>
			<b-col cols="12" v-if="errorMessage">
				<p class="text-right text-danger">{{ $t(errorMessage) }}</p>
			</b-col>
			<b-col cols="3">
				<h4 class="font-weight-bold">{{ $t('incomes.create.products-items') }}: <span
					class="text-danger">*</span></h4>
				<h4>#Всего: {{ totalCount }}</h4>
				<h6>Сумма без cкидка: {{ setBezSkidkaSum | currency({
					symbol:
					userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
					})}}</h6>
				<h6>Сумма: {{ setTotalSum | currency({
					symbol:
					userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
					})}}</h6>
				<h6>Оптом скидка(-):
					<i @click="openModalForOptomDiscount" style="padding-right: 5px"
					   class="fa fa-pencil-square-o cursor-pointer"
					   id="pos-edit-optom-discount"
					   title="Edit Discount" aria-hidden="true" data-toggle="modal"
					></i>
					<span>{{ discountOptom !== null ? discountOptom : "0.00" }}</span>
				</h6>
				<b-modal hide-footer v-model="discountOptomOpenModal"
						 @shown="focusMyOptomDiscount"
						 :title='`Оптом скидка`'>
					<wholesale-discount-optom @emitClose="closeOptomDiscount"
										@saveSuccess="saveOptomDiscount"
										ref="posOptomDiscount"
										:canceled="getCartItems.length === 0 || discountOptom === null"
					></wholesale-discount-optom>
				</b-modal>
			</b-col>
			<b-col cols="9">
				<b-input-group>
					<b-input-group-text
						slot="prepend"
					>
							<span class="input-group-addon">
								<i class="fa fa-barcode"></i>
							</span>
					</b-input-group-text>
					<b-form-input class="form-control mousetrap ui-autocomplete-input" id="search_product"
								  ref="searchBar"
								  placeholder="Название продукта/ Модель № / Штрихкод"
								  autofocus=""
								  @input="filterChanged"
								  v-model="posSearchValue"
								  onClick="setSelectionRange(0, value.length)"
								  name="search_product"
								  type="text" autocomplete="off"
					></b-form-input>

					<!-- PRODUCT SEARCH RESULT -->
					<div id="searchResult"
						 ref="searchResult"
						 v-click-outside="hideSearchResult"
						 :style="[getItems.length > 0 ? {'min-height': 'unset'} : {}]"
					>

						<with-keyboard-control-for-wholesale :listLength="getItems.length"
													   @selected="selectedHandler"
													   @escapeClicked="escapeClicked"
													   :current-index="computedCurrentIndex"
													   ref="withKeyboardControl"
						>
							<template slot-scope="{selectedIndex}">
								<loading
									v-if="searchLoading"
									width="60px"
									height="60px"
								></loading>

								<div
									v-for="(item, index) in getItems"
									class="d-flex justify-content-between foundProduct align-items-center"
									:class="{'selected': index === selectedIndex, 'disabled': (item.qty <= 0 || !item.qty)}"
									v-if="getItems.length > 0 && !searchLoading"
									:key="'searchItem' + index"
									@click="selectedHandler(index)"
								>
									<template>
										<div class="productName mb-0 d-flex">
											<div>
												{{ index + 1 }}.
											</div>
											<!--<div>
												<img
													class="posItemImage"
													:src="item.mainPhotoId ? imageUrl + item.mainPhotoId : `${publicPath}img/pos-images/default-thumbnail.jpg`"
													alt="itemImage"
												>
											</div>-->
											<div>
														<span>
														 {{ item.name ? item.name : '' }} / <strong>{{ item.artikul }}</strong> / {{ item.colorName }} / <strong>{{ item.size }}</strong>
													</span>
											</div>

										</div>
									</template>

									<template>
										<div class="productPrice">
											<p>
												<strong>Цена:</strong>
												<span
													:style="[item.priceUzs < 0 ? {'color': 'red'} : {'color': 'green'}]">
															{{ item.priceUzs | currency({
															symbol:
																userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
														}) }}
														</span>
											</p>
											<p>
												<strong>Кол-во:</strong>
												<span
													:style="[item.qty > 0 ? {'color': 'blue'} : {'color': 'red'}]">
															{{ item.qty ? item.qty : 0 }} {{ item.unitName ? item.unitName : 'шт.'}}
														</span>
											</p>
										</div>
										<!--<p class="productBreadcrumb">
											{{ item.subCategoryName }} / {{ item.sub2CategoryName }} / {{
											item.sub3CategoryName }} / <strong>{{ item.genderName }}</strong>
										</p>-->
									</template>
								</div>
								<p
									v-if="getItems.length == 0 && !searchLoading"
									style="padding: 10px;"
								>
									{{ $t('warehouse.document.itemNotFound') }}
								</p>
							</template>
						</with-keyboard-control-for-wholesale>
					</div>


					<b-input-group-text
						slot="append"
						style="cursor: pointer;"
						id="for-barcode"
					>
						<b-input-group-addon style="cursor: pointer;"
											 class="input-group-addon barcode-refresh"
											 @click="searchBarRefresh"
						>
							<i class="fa fa-refresh"></i>
						</b-input-group-addon>
					</b-input-group-text>

				</b-input-group>
				<!--Tabs-->
				<!--<b-tabs content-class="mt-3" @input="focusBarcodeInput" v-if="false">

					<b-modal v-model="openViewProductModal" id="modal-lg" hide-footer size="xl"
							 title="Посмотреть продукты">
						&lt;!&ndash;<span>{{viewItem}}</span>&ndash;&gt;

						<b-table class="generalTableClass"
								 striped="striped"
								 bordered="bordered"
								 small="small"
								 fixed="fixed"
								 :items="viewItem"
								 :fields="computedFields"
								 responsive="sm"
						>
							<template slot="index" slot-scope="data">
								{{ data.index + 1 }}
							</template>
							<template slot="priceUzs" slot-scope="data">
								{{ data.item.priceUzs | currency({symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back'}) }}
							</template>
							<template slot="incomeUzs" slot-scope="data">
								{{ data.item.incomeUzs | currency({symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back'}) }}
							</template>
						</b-table>
					</b-modal>

					<b-tab title="Search" active>
						<b-form-group
							breakpoint="lg"
							label-size="sm"
							label-cols="2"
							:label="$t('incomes.create.product')"
							label-for="refName"
							class="required mb-1"
						>
							<multiselect v-model="dropDowns.product.value"
										 :options="goodsForMultiselect"
										 :searchable="true"
										 :show-labels="false"
										 :internal-search="false"
										 :loading="dropDowns.product.loading"
										 :close-on-select="true"
										 label="name"
										 track-by="id"
										 @search-change="loadItems($event)"
										 :placeholder="$t('incomes.create.product')">

								<template slot="singleLabel" slot-scope="props">
									<span v-if="props.option.wrapped">
										<strong>Мешок - </strong>{{ props.option.barcode }} / {{ props.option.artikul }} / {{ props.option.colorName }} / {{ props.option.size
									}} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }}
									</span>
									<span v-else>
										{{ props.option.artikul }} / {{ props.option.colorName }} / {{ props.option.size
									}} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }}
									</span>
								</template>

								<template slot="option" slot-scope="option">
									<span v-if="option.option.wrapped">
										<strong>Мешок - </strong>{{ option.option.barcode }} / {{ option.option.artikul }} / {{ option.option.colorName }} / {{ option.option.size
										}} / {{ option.option.name ? option.option.name.substring(0, 30) : '' }}
									</span>
									<span v-else>
										{{ option.option.artikul }} / {{ option.option.colorName }} / {{ option.option.size
										}} / {{ option.option.name ? option.option.name.substring(0, 30) : '' }}
									</span>
								</template>
							</multiselect>
						</b-form-group>
						&lt;!&ndash;<div>
							<b-check v-if="isKirim" class="mb-4 pull-right" v-model="convert">{{
								$t('incomes.create.enable-currency') }}
							</b-check>

							<div class="clearfix"></div>
						</div>&ndash;&gt;

						<b-row
							v-if="isKirim || isTransfer">
							&lt;!&ndash;<b-col v-if="dropDowns.product.value && dropDowns.product.value.forPos" cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.incoming-price') + showUnit"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input :required="true"
													  size="sm"
													  id="inUsd"
													  type="number"
													  @focus="$event.target.select()"
													  v-model.number="newItem.incomingPriceUsd"
													  class="ml-1"
													  :placeholder="$t('incomes.create.incoming-price')"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm">USD</b-button>
										</b-input-group-addon>
									</b-input-group>

								</b-form-group>
							</b-col>&ndash;&gt;
							<b-col v-if="dropDowns.product.value && dropDowns.product.value.forPos && isKirim"
								   cols="6"
							>
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.incoming-price') + showUnit"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input :required="true"
													  size="sm"
													  ref="incomingPriceRef"
													  id="inUzs"
													  @focus="$event.target.select()"
													  type="number"
													  v-model.number="newItem.incomingPriceUzs"
													  @keyup.enter="focusNextInput('incomePrice')"
													  class="ml-1"
													  :placeholder="$t('incomes.create.incoming-price')"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm">{{ computedDepCurrencyName }}</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>
							</b-col>
							&lt;!&ndash;<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.price') + showUnit"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input :required="true"
													  size="sm"
													  type="number"
													  id="priceUsd"
													  @focus="$event.target.select()"
													  v-model.number="newItem.priceUsd"
													  class="ml-1"
													  :placeholder="$t('incomes.create.price')"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm">USD</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>
							</b-col>&ndash;&gt;
							<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.price') + showUnit"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input :required="true"
													  size="sm"
													  ref="sellPriceRef"
													  id="priceUzs"
													  type="number"
													  @focus="$event.target.select()"
													  v-model.number="newItem.priceUzs"
													  @keyup.enter="focusNextInput('sellPrice')"
													  :disabled="!isKirim"
													  class="ml-1"
													  :placeholder="$t('incomes.create.price')"></b-form-input>
										<b-input-group-addon>
											<b-button disabled size="sm">{{ computedDepCurrencyName }}</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>

						<b-row>
							<b-col class="col-6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.count')"
									label-for="refName"
									class="required"
								>
									<b-input-group size="sm">
										<b-form-input
											type="number"
											:required="true"
											ref="newItemCountRef"
											size="sm"
											id="count"
											@click="$event.target.select()"
											@focus="$event.target.select()"
											class="ml-1"
											@keyup.enter="addItem"
											v-model.number="newItem.count"
											:placeholder="$t('incomes.create.count')"></b-form-input>
										<b-input-group-addon v-if="unitName">
											<b-button disabled size="sm">{{ unitName }}</b-button>
										</b-input-group-addon>
									</b-input-group>

								</b-form-group>
							</b-col>
							<b-col v-if="newItem.itemId && (sections.includes(section))" cols="3">
								<span class="badge">{{ $t('incomes.balance') }}:</span> {{ balance }} <span>{{ unitName
								}}</span>
							</b-col>
							<b-col cols="1">

								<b-button v-if="isWrappedComputed && newItem.itemId" block size="sm" type="button"
										  variant="outline-primary"
										  @click="viewProduct(newItem)">
									<i style="color: black" class="fa fa-eye"></i></b-button>

								<b-button v-else-if="isWrappedComputed && lastAddedItem" block size="sm" type="button"
										  variant="outline-primary"
										  @click="viewProduct(lastAddedItem)">
									<i style="color: black" class="fa fa-eye"></i></b-button>
							</b-col>
						</b-row>
						<div class="form-group">
							<b-button type="button"
									  size="sm"
									  variant="outline-primary"
									  @click="addItem"
									  class="mr-4"
							>
								{{ $t('incomes.create.add-item') }}
							</b-button>
							<span v-if="successBarcode && lastAddedItem"><span class="text-success">Последний добавленный продукт: </span><strong> &nbsp;{{ lastAddedItem.artikul }} / {{ lastAddedItem.color }} / {{ lastAddedItem.size }} / {{ lastAddedItem.barcode }}</strong><br></span>
							<span v-if="itemFieldsNotFilled"
								  class="ml-3 text-danger">{{ $t('incomes.create.notFilledItem') }}</span>
						</div>
					</b-tab>
					<b-tab title="Barcode">
						<b-row>
							<b-col class="col-12">
								<b-input-group
									breakpoint="lg"
									label-size="sm"
									label-cols="2"
									:label="$t('incomes.create.barcode')"
									label-for="barcode"
									label-class="ml-1"
									class="required"
									size="sm"
								>
									<b-input-group-text slot="prepend">
								<span class="input-group-addon">
									<i class="fa fa-barcode"></i>
								</span>
									</b-input-group-text>
									<b-form-input
										:required="true"
										size="sm"
										autofocus
										id="barcodeInput"
										ref="barcodeInput"
										autocomplete="off"
										@input="itemBarcodeEntered"
										onClick="setSelectionRange(0, value.length)"
										v-model="barcodeInputValue"
										:placeholder="$t('incomes.create.barcode')">
									</b-form-input>
									<b-input-group-text slot="append" id="forBarcode">
										<b-input-group-addon style="cursor: pointer;"
															 class="input-group-addon barcode-refresh"
															 @click="clearBarcode"
										>
											<i class="fa fa-times"></i>
										</b-input-group-addon>
									</b-input-group-text>
								</b-input-group>
							</b-col>
							&lt;!&ndash;<b-col class="col-6" align-h="end">
								<b-check v-if="isKirim" class="mb-2 mt-2" v-model="convert">{{
									$t('incomes.create.enable-currency') }}
								</b-check>
							</b-col>&ndash;&gt;
							<template v-if="false">
								<b-col class="col-12">
									<h6 class="mb-2 mt-2">{{ itemWithBarcode.artikul }} / {{ itemWithBarcode.colorName
										}} / {{ itemWithBarcode.size }} / {{ itemWithBarcode.name ?
										itemWithBarcode.name.substring(0, 30) : '' }} /
										<strong>{{ itemWithBarcode.barcode
											}}</strong></h6>
								</b-col>
								<b-col class="col-6">
									<b-form-group
										breakpoint="lg"
										label-size="sm"
										label-cols="4"
										:label="$t('incomes.create.count')"
										label-for="barcodeItemCount"
										class="required"
									>
										<b-input-group size="sm">
											<b-form-input
												type="number"
												:required="true"
												size="sm"
												ref="barcodeItemCount"
												id="barcodeItemCount"
												@click="$event.target.select()"
												class="ml-1"
												@keyup.enter.native="barcodeItemCountEntered"
												v-model.number="newItem.count"
												:placeholder="$t('incomes.create.count')"></b-form-input>
											<b-input-group-addon v-if="unitName">
												<b-button disabled size="sm">{{ unitName }}</b-button>
											</b-input-group-addon>
										</b-input-group>
									</b-form-group>
								</b-col>
							</template>
							<template v-else-if="barcodeError">
								<b-col class="col-12 mt-2">
									<span class="text-danger">{{ $t('warehouse.document.itemNotFound') }} </span> <span><b> {{
									lastEnteredBarcode }}</b></span>
								</b-col>

							</template>
							<template v-else-if="successBarcode && lastAddedItem">
								<b-col class="col-9 mt-2">
									<span class="text-success">Последний добавленный продукт: </span> <b> &nbsp;{{
									lastAddedItem.artikul }} / {{ lastAddedItem.color }} / {{ lastAddedItem.size }} / {{
									lastAddedItem.barcode }}</b>
								</b-col>
								<b-col cols="1">

									<b-button v-if="isWrappedComputed" block size="sm" type="button" variant="outline-primary"
											  @click="viewProduct(lastAddedItem)">
										<i style="color: black" class="fa fa-eye"></i></b-button>
								</b-col>
								&lt;!&ndash;<b-col v-if="sections.includes(section)" class="col-3 mt-2 pl-0 pr-0">
									<span class="badge">{{ $t('incomes.balance') }}:</span> {{ balance > 0 ? balance - 1 : 0 }} <span>{{ unitName
								}}</span>
								</b-col>&ndash;&gt;
							</template>
							&lt;!&ndash;<template v-else>
								<b-col v-if="sections.includes(section)" class="col-3 mt-2">
									<span class="badge">{{ $t('incomes.balance') }}:</span> {{ balance > 0 ? balance - 1 : 0 }} <span>{{ unitName
								}}</span>
								</b-col>
							</template>&ndash;&gt;

						</b-row>
					</b-tab>
					<b-tab title="Excel" v-if="isKirim || isTransfer">
						<h3 style="color: red;">{{ $t('notFinishedMessage') }}</h3>
						<b-row>
							<b-col cols="12"><a :href="`${publicPath}excel/sample.xlsx`" disabled
												download>{{$t('excel.title')}}</a></b-col>

						</b-row>
						<br/>
						<b-row>
							<b-col cols="12">
								<b-form-file
									v-model="newItem.excelFile"
									browse-text="Просматривать"
									placeholder="Выберите файл ..."
									drop-placeholder="Перетащите файл сюда ..."
									size="sm"
									name="file"
									v-validate="{required:true}"
									:state="fileSelected"


								>
									<template slot="file-name" slot-scope="{ names }">
										<b-badge variant="dark">{{ names[0] }}</b-badge>
										<b-badge v-if="names.length > 1" variant="dark" class="ml-1">
											+ {{ names.length - 1 }} More files
										</b-badge>
									</template>
								</b-form-file>
							</b-col>
						</b-row>
						<br/>
						<b-row>
							<b-col cols="6">
								<p class="text-danger" v-if="fileNotSelectMessage"> Пожалуйста выберите файл</p>
							</b-col>
							<b-col cols="6">

								<b-button @click="uploadFileToServer" class="pull-right"
										  :disabled="true"
										  variant="primary">Загрузить файл
								</b-button>
							</b-col>
						</b-row>


					</b-tab>
				</b-tabs>-->
				<!--Tabs-->
			</b-col>
		</b-row>
		<div v-if="loading" class="spinner-wrapper">
			<b-spinner></b-spinner>
		</div>
	</div>
</template>

<script>
	import GoodsService from "../../../../services/goods.service";
	import { mapActions, mapState, mapGetters } from 'vuex'
	import WhDocument from "../../../../services/wh-document.service";
	import Multiselect from 'vue-multiselect'
    import WithKeyboardControlForWholesale from "./WithKeyboardControlForWholesale";
    import WholesaleDiscountOptom from "./WholesaleDiscountOptom";
import { convertRuToEn } from "@/utils/helper";
    import Loading from '../../../components/Loading'

    const initial = {
		id: null,
		documentId: null,
		itemId: null,
		itemName: null,
		count: 1,
		//incomingPriceUsd: null,
		priceUsd: null,
		//incomingPriceUzs: null,
		priceUzs: null,
		providerId: null,
		providerName: null,
		wrapped: false,
		inventoryNum: null,
	};

	export default {
		name: 'CreateItems',

		props: {
			items: {
				type: Array,
				default: null
			},
			allTotalCount: {type: Number},
			incomeTotal: {type: Number},
			priceTotal: {type: Number},
			documentId: {},
			department: {},
			toDepartmentId: null,
			section: {
				type: String,
				default: 'KIRIM'
			},
			currencyRate: {
				type: Number,
				default: -1
			},
            depCurrencyName: {
			    type: String,
				default: ''
			}
		},

		components: {
			Multiselect,
            WithKeyboardControlForWholesale,
            WholesaleDiscountOptom,
			Loading,
			SelectOrCreate: () => import('../../../components/SelectOrCreate')
		},

		created() {
            this.$barcodeScanner.init(this.posBarcodeScanned);
			/*if (this.sections.includes(this.section)) {
				this.pushable = false;
			}*/
		},
        mounted() {
            this.$root.$on('focusSearchBarWholesale', () => {
                this.focusSearchBar();
            });
        },
		destroyed() {
			this.$barcodeScanner.destroy();
		},

		data() {
			return {
                discountOptomOpenModal: false,
                discountOptom: null,
                isBarcodeScanned: false,
                currentIndex: 0,
                posSearchValue: '',
				computedFields: [
					// {
					// 	key: 'id',
					// 	label: '№',
					// 	sortable: true
					// },
					{
						key: 'artikul',
						label: "Артикул",
						'class': 'incomeItemArtikul',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'colorName',
						label: "Цвет",
						'class': 'incomeItemArtikul',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'size',
						label: "Размер",
						'class': 'incomeItemSize',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'name',
						label: this.$t('incomes.create.product'),
						'class': 'not-first',
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'amount',
						label: this.$t('incomes.create.count'),
						'class': 'td-30',
						sortable: true,
						visible: true,
						changebale: true
					},

					{
						key: 'barcode',
						label: 'Штрихкод',
					},
					{
						key: 'priceUzs',
						label: this.section == 'KIRIM' ? this.$t('money.newUzb') : 'Цена (штук)',

					},
					// {
					//     key: 'incomeUsd',
					//      label: this.$t('money.incomeUsd'),
					//
					// },
					// {
					//     key: 'newUsd',
					//     label: this.$t('money.newUsd'),
					//
					// },
					// {
					//     key: 'priceUsd',
					//     label: `${this.$t('incomes.create.price')} (USD)`,
					//     'class': 'td-30',
					//     sortable: true,
					//     visible: true,
					//     changebale: true
					// },
					// {
					// 	key: 'priceUzs',
					// 	label: `${this.$t('incomes.create.price')} (Сумма)`,
					// 	'class': 'td-30',
					// 	sortable: true,
					// 	visible: true,
					// 	changebale: true
					// },
					{
						key: 'incomeUzs',
						label: 'Цена (приход)',
						'class': 'td-30',
						sortable: true,
						visible: true,
						changebale: true
					},
					// {
					// 	label: `${this.$t('incomes.actions')}`,
					// 	key: 'actions',
					// 	'class': 'table_actions',
					// 	visible: true,
					// 	changebale: false
					// }

				],
				publicPath: process.env.BASE_URL,
				loading: false,
				itemFieldsNotFilled: false,
				noDepartment: false,
				fileSelected: null,
				fileNotSelectMessage: false,
				barcodeFn: false,
				dropDowns: {
					product: {
						items: [],
						value: null,
						loading: false,
						search: {
							page: 1,
							limit: 10,
							attributes: [{
								field: 'name',
								value: '',
								option: 'CONTAINS'
							}]
						}
					},
				},
				lastEnteredBarcode: null,
				lastAddedItem: null,
				openViewProductModal: false,
				successBarcode: null,
				newItem: {
					id: null,
					documentId: null,
					itemId: null,
					itemName: null,
					count: 1,
					//incomingPriceUsd: null,
					priceUsd: null,
					//incomingPriceUzs: null,
					priceUzs: null,
					providerId: null,
					providerName: null,
					inventoryNum: null,
					wrapped: false,
					barcode: null,
					excelFile: ''
				},
				barcodeInputValue: '',
				timeout: null,
				unitName: '',
				viewItem: [],
				convert: false,
				isWrapped: false,
				// balance: 0,
				pushable: true,
				errorMessage: null,
				sections: ['CHIQIM', 'KOCHIRISH', 'SPISAT']
			}
		},

		methods: {
            async setOptomPromotion(payload) {
                await this.$store.commit('pos/setCustomPromotionForItem', payload);
            },
            async saveOptomDiscount(event) {
                if (event.promotionType === "%") {
                    this.discountOptom = event.discount + ' ' + "%"
                } else {
                    this.discountOptom = event.discount + ' ' + "сум"
                }
                if (this.getCartItems.length !== 0) {
                    this.getCartItems.forEach((item, index) => {
                        let obj = {}
                        if (event.promotionType === "%") {
                            obj.promotionType = "%";
                            obj.discount = event.discount;
                            obj.saleId = this.currentSaleId;
                        } else {
                            obj.promotionType = 'PUL';
                            obj.discount = event.discount;
                            obj.saleId = this.currentSaleId;

                        }
                        let payload = {
                            index: index,
                            obj: obj
                        }
                        this.setOptomPromotion(payload)
                    })
                    this.$root.$emit('savePosDraft');
                }
                if (event.setToNull) {
                    this.discountOptom = null
                }
                await this.editDraft(this.tempForSale);
                this.discountOptomOpenModal = false

            },
            closeOptomDiscount(event) {
                this.discountOptomOpenModal = event;
            },
            focusMyOptomDiscount() {
                this.$refs.posOptomDiscount.$refs.fixedOptomRef.focus();
                this.$refs.posOptomDiscount.$refs.percentageOptomRef.focus();
            },
            openModalForOptomDiscount() {
                this.discountOptomOpenModal = true
            },
		    /**
			 * POS ITEM SEARCH INPUT METHODS BEGIN */
            ...mapActions('pos', [
                'getItemsForPos', 'increaseCount', 'addToCartAction', 'setIncrementValue',
                'decreaseCount', 'deleteFromCartAction', 'saleFinish', 'createPosDraft',
                'editDraft', 'getLatestSuspends', 'suspendSale', 'setSaleItemForDiscountModal', 'setSusPendClient', 'setErrorOccurNotHappen', 'editDraftOptom'
            ]),
            async addToCart(item) {
                this.hideSearchResult();
                this.clearSearchBar();
                this.focusSearchBar();
                await this.addToCartAction(item);
                this.isBarcodeScanned = false;
                this.$root.$emit('savePosDraft', item);
                // await this.savePos('draft');
            },
            async filterChanged(newVal) {
                this.currentIndex = 0;
                if (this.$refs.withKeyboardControl) {
                    this.$refs.withKeyboardControl.selectedIndex = 0;
                }
                if (newVal.length >= 2) {
                    /** BU RESULT TOPILMASA SEARCHINPUT VALUENI SELECT QILIB QO'YISHNI TO'G'IRLASH UCHUN YOZILGAN **/
                    clearTimeout(this.timeout);
                    let vm = this;
                    this.timeout = setTimeout(async function () {
                        vm.showSearchResult();
                        if (!vm.isBarcodeScanned) {
                            await vm.getItemsForPos(newVal);
                        }
                        // await vm.showSearchResult();
                    }, 5);
                    // this.showSearchResult();
                    // await this.getItemsForPos(newVal);
                    /*if (this.getItems.length == 1) {
						this.hideSearchResult();
						await this.selectedHandler(0)
					} else {
						this.showSearchResult();
					}*/
                } else {
                    this.hideSearchResult();
                }

            },
            async posBarcodeScanned(barcodeNum) {
				let barcodeNumber  = convertRuToEn(barcodeNum)
                if (barcodeNumber.length > 3) {
                    this.isBarcodeScanned = true;
                    if (this.getItems.length <= 0) {
                        await this.getItemsForPos(barcodeNumber);
                    }
                    if (this.getItems.length > 0) {
                        if (this.getItems[0].qty > 0 || this.isReturn) {
                            await this.addToCart(this.getItems[0]);
                        }
                    }
                }
            },
            showSearchResult() {
                this.currentIndex = 0;
                if (this.$refs.withKeyboardControl) {
                    this.$refs.withKeyboardControl.addKeyHandler();
                }
                this.$refs.searchResult.style.display = 'block'
            },
            hideSearchResult() {
                if (this.$refs.withKeyboardControl) {
                    this.$refs.withKeyboardControl.removeKeyHandler();
                }
                this.$refs.searchResult ? this.$refs.searchResult.style.display = 'none' : '';
                this.$store.commit('pos/setPosItems', []);
            },
            focusSearchBar(fromChild = '') {
                this.$refs.searchBar.focus();
                this.$refs.searchBar.$el.value = '';
                if (fromChild == 'clientForPos') {
                    this.clearSearchBar();
                }
            },
            clearSearchBar() {
                this.posSearchValue = '';
                this.$refs.searchBar.$el.value = '';
            },
            searchBarRefresh() {
                this.clearSearchBar();
                this.focusSearchBar();
            },
            async selectedHandler(selectedIndex) {
                this.currentIndex = selectedIndex;
                if (this.getItems.length > 0) {
                    if (this.getItems[selectedIndex].qty > 0 || this.isReturn) {
                        await this.addToCart(this.getItems[selectedIndex]);
                    }
                } else {
                    /*await this.hideSearchResult();
					await this.clearSearchBar();*/
                }
            },
            escapeClicked() {
                this.hideSearchResult();
                this.clearSearchBar();
                this.focusSearchBar();
            },
            /**
             * POS ITEM SEARCH INPUT METHODS END */
			/*viewProduct(item) {
				WhDocument.getViewPRoductItems(item.itemId)
					.then(response => {
						this.viewItem = response.data;
					})
				this.openViewProductModal = true;
			},*/

			/*...mapActions('goods', [
				'fetchGoodsWithKeyword', 'fetchItemWithBarcode'
			]),*/
			/*...mapActions('warehouse', [
				'lastPriceByItemId', 'loadBalance'
			]),*/
			/*clearBarcode() {
				this.barcodeInputValue = '';
				this.focusBarcodeInput(1);
			},*/
			/**
			 *  Load and search items
			 * @param $event
			 * @param by
			 */
			/*async loadItems($event, by = 'name') {
				this.dropDowns.product.loading = true;
				/!*if ($event !== null) {
					this.dropDowns.product.search.attributes[0].value = $event;
				}*!/
				await this.fetchGoodsWithKeyword($event);
				/!*GoodsService.fetchGoodsWithKeywoard($event).then(response => {
					this.dropDowns.product.items = (response.data);
				})*!/
				if (this.withKeywordError) {
					this.$vs.notify({
						text: this.withKeywordError,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				}
				this.dropDowns.product.loading = false;
			},*/

			/**
			 *  Add Warehouse item
			 */
			/*async addItem(eventOrFromWhere) {
				if (!this.department) {
					this.$vs.notify({
						text: "Выберите Подразделение",
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					return 0;
				}
				if (this.dropDowns.product.value || this.itemWithBarcode) {
					this.loading = true;
					this.newItem.documentId = this.documentId;
					this.newItem.inventoryNum = this.balance;
					this.newItem.count = (this.newItem.count && this.newItem.count > 0) ? this.newItem.count : 1;

					if (!this.isKirim && this.newItem.count > this.balance) {
						this.newItem.count = this.balance;
					}
					if (this.newItem.count <= 0) {
						this.$vs.notify({
							time: 1200,
							title: "Количество",
							text: 'Проверьте количество товара!',
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
						if (this.$refs.newItemCountRef) {
							this.$refs.newItemCountRef.focus();
						}
						this.loading = false;
						return 0;
					}
					this.newItem.toDepartmentId = this.toDepartmentId
					this.newItem.fromDepartmentId = this.department
					let findIndex = this.items.findIndex(el => {
						return el.itemId == this.newItem.itemId;
					});
					if (findIndex >= 0) {
						// let oldCount = this.items[findIndex].count;
						if ((this.items[findIndex].count + this.newItem.count <= this.items[findIndex].realBalance) || this.section == 'KIRIM') {
							if (this.isTransfer) {
								if (eventOrFromWhere !== 'fromBarcodeFn') {
									this.newItem.barcode = this.dropDowns.product.value.barcode;
									this.newItem.artikul = this.dropDowns.product.value.artikul;
									this.newItem.color = this.dropDowns.product.value.colorName;
									this.newItem.size = this.dropDowns.product.value.size;
									this.newItem.unitName = this.dropDowns.product.value.unitName;
								}
								let temp = Object.assign({}, this.newItem);
								this.lastAddedItem = this.newItem;
								this.successBarcode = true;
								this.$store.commit('goods/setBarcodeError', false);
								this.$emit('success', temp);
								if (this.newItem.wrapped) {
									this.isWrapped = true;
								} else {
									this.isWrapped = false;
								}
								Object.assign(this.newItem, initial);
								this.newItem.priceUsd = null;
								this.newItem.priceUzs = null;
								this.newItem.count = 1;
								this.newItem.incomingPriceUsd = null
								this.dropDowns.product.value = null;
								this.incomingPriceUzs = null;
								this.loading = false;
							} else {
								this.newItem.id = this.items[findIndex].id;
								await WhDocument.updateItem(this.newItem).then(response => {
									this.lastAddedItem = response.data;
									this.successBarcode = true;
									this.$store.commit('goods/setBarcodeError', false);
									this.$emit('success', response.data);
									if (this.newItem.wrapped) {
										this.isWrapped = true;
									} else {
										this.isWrapped = false;
									}
									Object.assign(this.newItem, initial);
									this.newItem.priceUsd = null;
									this.newItem.priceUzs = null;
									this.newItem.count = 1;
									this.newItem.incomingPriceUsd = null
									this.dropDowns.product.value = null;
									this.incomingPriceUzs = null;
									this.loading = false;
								}).catch((error) => {
									this.lastAddedItem = null;
									this.successBarcode = false;
									this.loading = false;
								})
							}
						} else {
							this.$emit('changeRowVariant', findIndex);
							this.loading = false;
							this.$vs.notify({
								title: "Количество",
								text: 'Проверьте количество товаров!',
								color: 'warning',
								icon: 'close',
								position: 'top-right'
							});
						}
					} else {
						if (this.isTransfer) {
							if (eventOrFromWhere !== 'fromBarcodeFn') {
								this.newItem.barcode = this.dropDowns.product.value.barcode;
								this.newItem.artikul = this.dropDowns.product.value.artikul;
								this.newItem.color = this.dropDowns.product.value.colorName;
								this.newItem.size = this.dropDowns.product.value.size;
								this.newItem.unitName = this.dropDowns.product.value.unitName;
							}
							let temp = Object.assign({}, this.newItem);
							this.lastAddedItem = this.newItem;
							this.successBarcode = true;
							this.$store.commit('goods/setBarcodeError', false);
							this.$emit('success', temp);
							this.loading = false;
							setTimeout(() => {
								if (this.newItem.wrapped) {
									this.isWrapped = true;
								} else {
									this.isWrapped = false;
								}
								Object.assign(this.newItem, initial);
								this.dropDowns.product.value = null;
								// this.balance = 0;
								this.$store.commit('warehouse/resetCurrentItemBalance');
								this.unitName = '';
								if (this.newItem.incomingPriceUsd) {
									this.newItem.incomingPriceUsd = null
								}
								if (this.newItem.incomingPriceUzs) {
									this.newItem.incomingPriceUzs = null
								}
								this.newItem.priceUsd = null;
								this.newItem.priceUzs = null
							}, 100);
						} else {
							await WhDocument.storeItem(this.newItem).then(response => {
                                this.lastAddedItem = response.data;
                                this.successBarcode = true;
                                this.$store.commit('goods/setBarcodeError', false);
                                this.$emit('success', response.data);

                                this.loading = false;
                                setTimeout(() => {
                                    if (this.newItem.wrapped) {
                                        this.isWrapped = true;
                                    } else {
                                        this.isWrapped = false;
                                    }
                                    Object.assign(this.newItem, initial);
                                    this.dropDowns.product.value = null;
                                    // this.balance = 0;
                                    this.$store.commit('warehouse/resetCurrentItemBalance');
                                    this.unitName = '';
                                    if (this.newItem.incomingPriceUsd) {
                                        this.newItem.incomingPriceUsd = null
                                    }
                                    if (this.newItem.incomingPriceUzs) {
                                        this.newItem.incomingPriceUzs = null
                                    }
                                    this.newItem.priceUsd = null;
                                    this.newItem.priceUzs = null
                                }, 100);
                            }).catch((error) => {
                                this.lastAddedItem = null;
                                this.successBarcode = false;
                                this.loading = false;
                            })
						}
					}
				} else {
					this.$vs.notify({
						time: 1200,
						title: 'Пожалуйста, выберите продукт',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
					this.itemFieldsNotFilled = true;
				}
			},*/
			/*uploadFileToServer() {
				this.$validator.validate().then(valid => {
					if (valid) {
						this.fileNotSelectMessage = false;
						this.fileSelected = true;
						let formData = new FormData()
						formData.append('upload', this.newItem.excelFile)
						this.axios.post(`excel-parser/save-full-file/${this.documentId}`,
							formData,
							{
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							}
						).catch(error => {
							this.$vs.notify({
								time: 1200,
								title: this.$t('words.error'),
								text: 'Ошибка сервера! попробуйте чуть позже',
								color: 'danger',
								icon: 'close',
								position: 'top-right'
							})
						})

					} else {
						this.fileNotSelectMessage = true;
						this.fileSelected = false;
					}
				});

			},*/
			/*loadBalance(item) {
				WhDocument.balanceByItem(this.department, item).then(response => {
					this.balance = response.data;
					this.pushable = this.balance > 0;
				});
			},*/
			/*async loadLastPrice(itemId, fromWhere) {
				let pricingItemPayload = {
					itemId: itemId,
					department: this.department
				}
				await this.lastPriceByItemId(pricingItemPayload);
				if (this.pricingItem) {
					if (this.pricingItem.incomeUzs > 0) {
						this.newItem.incomingPriceUzs = this.pricingItem.incomeUzs;
					} else {
						this.newItem.incomingPriceUzs = null;
					}
					if (this.pricingItem.priceUzs > 0) {
						this.newItem.priceUzs = this.pricingItem.priceUzs;
					} else {
						this.newItem.priceUzs = null;
					}
				}

				let findIndex = this.items.findIndex(el => {
					return el.itemId == itemId;
				});
				if (findIndex >= 0) {
					this.newItem.incomingPriceUzs = this.items[findIndex].incomingPriceUzs;
					this.newItem.priceUzs = this.items[findIndex].priceUzs;
				} else if (this.pricingItem.priceUzs > 0) {
					this.newItem.priceUzs = this.pricingItem.priceUzs;
				} else if (this.pricingItem.incomeUzs > 0) {
					this.newItem.incomingPriceUzs = this.pricingItem.incomeUzs;
				}
				if (!this.newItem.incomingPriceUzs) {
					if (this.$refs.incomingPriceRef) {
						this.$refs.incomingPriceRef.focus();
					}
				} else if (!this.newItem.priceUzs) {
					if (this.$refs.sellPriceRef) {
						this.$refs.sellPriceRef.focus();
					}
				} else {
					if (this.$refs.newItemCountRef) {
						this.$refs.newItemCountRef.focus();
					}
				}
				if (this.barcodeFn || this.isBarcodeScanned) {
					// this.successBarcode = true;
					if (!this.isKirim) {
						let itemBalancePayload = {
							itemId: this.newItem.itemId,
							department: this.department
						}
						await this.loadBalance(itemBalancePayload);
						this.pushable = this.balance > 0
					}
					if (fromWhere == 'fromBarcodeFn') {
						await this.addItem(fromWhere);
					} else {
						await this.addItem();
					}
					this.barcodeFn = false;
					this.isBarcodeScanned = false;
				}
				if (this.currentPricingItemError || this.currentItemBalanceError) {
					this.newItem.incomingPriceUzs = null;
					this.newItem.priceUzs = null;
					this.$refs.incomingPriceRef.focus();
					this.barcodeFn = false;
					this.isBarcodeScanned = false;
				}
				/!*WhDocument.lastPriceOfItem(this.department, itemId).then(response => {
					let pricingItem = response.data;
					if (pricingItem.incomeUzs > 0) {
						this.newItem.incomingPriceUzs = pricingItem.incomeUzs;
					} else {
						this.newItem.incomingPriceUzs = null;
					}
					if (pricingItem.priceUzs > 0) {
						this.newItem.priceUzs = pricingItem.priceUzs;
					} else {
						this.newItem.priceUzs = null;
					}
					return pricingItem;
				}).then(pricingItem => {
					let findIndex = this.items.findIndex(el => {
						return el.itemId == itemId;
					});
					if (findIndex >= 0) {
						this.newItem.incomingPriceUzs = this.items[findIndex].incomingPriceUzs;
						this.newItem.priceUzs = this.items[findIndex].priceUzs;
					} else if (pricingItem.priceUzs > 0) {
						this.newItem.priceUzs = pricingItem.priceUzs;
					} else if (pricingItem.incomeUzs > 0) {
						this.newItem.incomingPriceUzs = pricingItem.incomeUzs;
					}
					if (!this.newItem.incomingPriceUzs) {
						if (this.$refs.incomingPriceRef) {
							this.$refs.incomingPriceRef.focus();
						}
					} else if (!this.newItem.priceUzs) {
						if (this.$refs.sellPriceRef) {
							this.$refs.sellPriceRef.focus();
						}
					} else {
						if (this.$refs.newItemCountRef) {
							this.$refs.newItemCountRef.focus();
						}
					}
					if (this.barcodeFn || this.isBarcodeScanned) {
						// this.successBarcode = true;
						if (this.isTransfer) {
							this.loadBalance(this.newItem.itemId)
						}
						/!*this.barcodeFn = false;
						this.isBarcodeScanned = false;*!/
					}
					return true;
				}).then(boolean => {
					if (this.barcodeFn || this.isBarcodeScanned) {
						// this.successBarcode = true;
						this.addItem();
						this.barcodeFn = false;
						this.isBarcodeScanned = false;
					}
				}).catch(error => {
					this.newItem.incomingPriceUzs = null;
					this.newItem.priceUzs = null;
					this.$refs.incomingPriceRef.focus();
					this.barcodeFn = false;
					this.isBarcodeScanned = false;
				});*!/
			},*/
			/*focusNextInput(fromInput) {
				if (fromInput == 'incomePrice') {
					if (!this.newItem.incomingPriceUzs || this.newItem.incomingPriceUzs == '') {
						this.$refs.incomingPriceRef.focus();
					} else {
						this.$refs.sellPriceRef.focus();
					}
				} else {
					if (!this.newItem.priceUzs || this.newItem.priceUzs == '') {
						this.$refs.sellPriceRef.focus();
					} else {
						this.$refs.newItemCountRef.focus();
					}
				}
				/!*if (!this.newItem.incomingPriceUzs || this.newItem.incomingPriceUzs == '') {
					this.$refs.incomingPriceRef.focus();
				} else if (!this.newItem.priceUzs || this.newItem.priceUzs == '') {
					this.$refs.sellPriceRef.focus();
				} else {
					this.$refs.newItemCountRef.focus();
				}*!/
			},*/
			/*itemBarcodeEntered(val) {
				if (!this.isBarcodeScanned) {
					clearTimeout(this.timeout);
					this.barcodeFn = true;
					let vm = this;
					this.timeout = setTimeout(async function () {
						if (!vm.department) {
							vm.noDepartment = true;
							vm.clearBarcodeInput();
							vm.focusBarcodeInput(1);
							vm.barcodeFn = false;
							return 0;
						}
						if (val.length > 3 && !vm.isBarcodeScanned) {
							vm.lastEnteredBarcode = val;
							await vm.fetchItemWithBarcode(val);
							vm.clearBarcodeInput();
							if (vm.itemWithBarcode) {
								vm.unitName = vm.itemWithBarcode.unitName;
								vm.newItem.itemId = vm.itemWithBarcode.id;
								vm.newItem.itemName = vm.itemWithBarcode.name;
								vm.newItem.count = 1;
								vm.loadLastPrice(vm.itemWithBarcode.id);
								// vm.$refs.barcodeItemCount.focus();
							} else if (vm.barcodeError) {
								vm.clearBarcodeInput();
								vm.focusBarcodeInput(1);
								vm.barcodeFn = false;
								vm.successBarcode = false;
								vm.$vs.notify({
									time: 1200,
									title: '{{ $t('warehouse.document.itemNotFound') }}',
									color: 'danger',
									icon: 'close',
									position: 'top-right'
								});
							}
						}
					}, 100);
				}
			}
			,*/
			/*async barcodeScanned(barcode) {
				this.isBarcodeScanned = true;
				this.barcodeFn = false;
				this.lastEnteredBarcode = barcode;
				if (!this.department) {
					this.noDepartment = true;
					this.clearBarcodeInput();
					this.focusBarcodeInput(1);
					this.isBarcodeScanned = false;
					this.successBarcode = false;
					return 0;
				}
				if (this.isBarcodeTab) {
					await this.fetchItemWithBarcode(barcode);
					this.clearBarcodeInput();
					if (this.itemWithBarcode) {
						this.isWrapped = this.itemWithBarcode.wrapped
						this.unitName = this.itemWithBarcode.unitName;
						this.newItem.itemId = this.itemWithBarcode.id;
						this.newItem.itemName = this.itemWithBarcode.name;
						this.newItem.count = 1;
						this.newItem.wrapped = this.itemWithBarcode.wrapped;
						if (this.isTransfer) {
							this.newItem.barcode = this.itemWithBarcode.barcode;
							this.newItem.artikul = this.itemWithBarcode.artikul;
							this.newItem.color = this.itemWithBarcode.colorName;
							this.newItem.size = this.itemWithBarcode.size;
						}
						await this.loadLastPrice(this.itemWithBarcode.id, 'fromBarcodeFn');
						/!*if (this.isTransfer) {
							await this.loadBalance(this.itemWithBarcode.id)
						}*!/
						this.$refs.barcodeInput.focus();
						// vm.$refs.barcodeItemCount.focus();
					} else if (this.barcodeError) {
						this.isBarcodeScanned = false;
						this.successBarcode = false;
						this.clearBarcodeInput();
						this.focusBarcodeInput(1);
						this.$vs.notify({
							time: 1200,
							title: '{{ $t('warehouse.document.itemNotFound') }}',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}
				}
			},*/
			/*barcodeItemCountEntered() {
				if (this.newItem.count > 0) {
					this.addItem();
					this.$store.commit('goods/setItemWithBarcode', null);
					this.focusBarcodeInput(1);
				}
			}
			,*/
			/*focusBarcodeInput($event) {
				if ($event == 1) {
					// this.$barcodeScanner.init(this.itemBarcodeEntered);
					this.$refs.barcodeInput.focus();
					this.$store.commit('goods/setBarcodeTab', true);
					this.$refs.barcodeInput.$el.value = '';
					this.$refs.barcodeInput.focus();
				} else {
					// this.$barcodeScanner.destroy();
					this.$store.commit('goods/setBarcodeTab', false);
					this.newItem.incomingPriceUzs = null;
					this.newItem.priceUzs = null;
				}
			}
			,*/
			/*clearBarcodeInput() {
				this.barcodeInputValue = '';
				this.$refs.barcodeInput.$el.value = '';
			}
			,*/
		},

		watch: {
			'department': {
				handler() {
					this.dropDowns.product.value = null;
				}
			},
			/*'dropDowns.product.value': {
				async handler(newValue) {
					if (newValue) {
						this.newItem.wrapped = newValue.wrapped;
						this.isWrapped = newValue.wrapped;
					}

					if (!this.department) {
						this.noDepartment = true;
						return 0;
					}
					this.noDepartment = false;
					if (!newValue) {
						this.unitName = '';
						this.newItem.incomingPriceUzs = null;
						this.newItem.priceUzs = null;
						// this.balance = 0;
						this.$store.commit('warehouse/resetCurrentItemBalance');
						return;
					}
					this.itemFieldsNotFilled = false;

					if ((this.sections.includes(this.section)) && this.department) {
						this.errorMessage = null;
						let itemBalancePayload = {
							itemId: newValue.id,
							department: this.department
						}
						await this.loadBalance(itemBalancePayload);
						if (this.balance > 0) {
							this.newItem.count = 1;
						} else {
							this.newItem.count = 0;
						}
						if (this.section == 'KOCHIRISH') {

							this.loadLastPrice(newValue.id);
						}
						if (this.$refs.newItemCountRef) {
							this.$refs.newItemCountRef.focus();
						}
					} else if (this.sections.includes(this.section) && !this.department) {
						this.dropDowns.product.value = null;
						this.errorMessage = 'incomes.select-department'
					} else if (!this.sections.includes(this.section) && this.department) {
						this.newItem.count = 1;
						this.loadLastPrice(newValue.id);
					}
					/!*if (!this.sections.includes(this.section) && this.department && newValue) {
						if (!this.newItem.incomingPriceUzs) {
							if(this.$refs.incomingPriceRef) {
								this.$refs.incomingPriceRef.focus();
							}
						} else if (!this.newItem.priceUzs) {
							if(this.$refs.sellPriceRef) {
								this.$refs.sellPriceRef.focus();
							}
						} else {
							if(this.$refs.newItemCountRef) {
								this.$refs.newItemCountRef.focus();
							}
						}
					}*!/
					this.unitName = newValue.unitName;
					this.newItem.itemId = newValue.id;
					this.newItem.itemName = newValue.name;
				}
			},*/
			isBarcodeTab: {
				handler(newVal) {
					if (newVal) {
						// this.$barcodeScanner.init(this.barcodeScanned);
						this.$refs.barcodeInput.$el.value = '';
						this.$refs.barcodeInput.focus();
					} else {
						// this.$barcodeScanner.destroy();
					}
				}
			},
			noDepartment: {
				handler(newVal) {
					if (newVal) {
						this.$vs.notify({
							text: "Выберите Подразделение",
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
						this.dropDowns.product.value = null;
						this.noDepartment = false;
					}
				}
			},
			'newItem.priceUsd': {
				handler(newValue) {
					if (this.currencyRate !== -1 && this.convert) {
						this.newItem.priceUzs = newValue * this.currencyRate;
					}
				}
			},
			'newItem.incomingPriceUsd': {
				handler(newValue) {
					if (this.currencyRate !== -1 && this.convert) {
						this.newItem.incomingPriceUzs = newValue * this.currencyRate;
					}
				}
			},

			'newItem.incomingPriceUzs': {
				handler(newValue) {
					if (this.currencyRate !== -1 && this.convert) {
						this.newItem.incomingPriceUsd = newValue / this.currencyRate;
					}
				}
			},


			'newItem.priceUzs': {
				handler(newValue) {
					if (this.currencyRate !== -1 && this.convert) {
						this.newItem.priceUsd = newValue / this.currencyRate;
					}
				}
			},

			'newItem.count': {
				handler(newValue) {
					if (this.sections.includes(this.section) && newValue > this.balance) {
						setTimeout(() => {
							this.newItem.count = this.balance;
						}, 100);
					}
				}
			},
			'newItem.excelFile': {
				handler(newValue) {
					if (newValue === null) {
						this.fileSelected = null
					} else {
						this.fileNotSelectMessage = false
						this.fileSelected = true
					}

				}
			},
		},

		computed: {
            setTotalSum() {
                let resultSum = 0;
                for (let i = 0; i < this.getCartItems.length; i++) {
                    resultSum += this.getCartItems[i].discountPriceUzs * this.getCartItems[i].count;
                }
                return resultSum;
            },
            setBezSkidkaSum(){
                let resultSum1 = 0;
                for (let i = 0; i <this.getCartItems.length; i++) {
                    resultSum1 += this.getCartItems[i].priceUzs * this.getCartItems[i].count;
                }
                return resultSum1;
            },
            computedCurrentIndex() {
                return this.currentIndex;
            },
            ...mapState('pos', [
                'totalCount', 'totalSum', 'checkPage', 'finalTotalSum', 'realTotalSum', 'comment',
                'shopName', 'currentSaleNumber',
                'currentSaleId',
                'shopAddress', 'cashierFullName', 'currentSellerName','sellerId',
                'currentSuspendId', 'currentSaleSuspendNumber', 'lastSuspendedSaleNumber', 'saleItemForDiscountModal', 'discount', 'customPromotion', 'errorOccur',
                'searchLoading', 'saleFinishError', 'saleFinishLoading',
                'isReturn'
            ]),
            ...mapGetters('pos', [
                'getItems', 'getCartItems', 'getDiscountItemForModal'
            ]),
			computedDepCurrencyName() {
			  return this.depCurrencyName || this.userDepCurrencyName;
			},
			isWrappedComputed() {
				return this.isWrapped;
			},
			...mapState(['userDepCurrencyName']),
			...mapState('goods', [
				'goodsForMultiselect', 'withKeywordError',
				'itemWithBarcode', 'barcodeError', 'isBarcodeTab'
			]),
			...mapState('warehouse', [
				'pricingItem', 'balance',
				'currentItemBalanceError', 'currentPricingItemError'
			]),
			isKirim() {
				return this.section === 'KIRIM';
			},
			isChiqim() {
				return this.section === 'CHIQIM';
			},
			isTransfer() {
				return this.section === 'KOCHIRISH';
			},
			showUnit() {
				return (this.unitName) ? ` (${this.unitName})` : ``;
			},
			isEnable() {
				return (this.loading || !this.pushable || this.newItem.count < 1) && this.unitName !== null;
			}
		}
	}
</script>

<style scoped lang="scss">
	.foundProduct {
		&.disabled {
			background-color: #eeeeee;
		}

		&.selected {
			background-color: #ccc;
		}
	}
	#searchResult {
		display: none;
		position: absolute;
		top: 100%;
		width: 89.25%;
		border: 1px solid #c5c5c5;
		left: 5.55%;
		background: #ffffff;
		z-index: 101;
		max-height: 29rem;
		min-height: 80px;
		overflow-x: auto;

	.posItemImage {
		width: 40px;
		height: auto;
		object-fit: cover;
		margin: 0 10px 0 5px;
	}

	.foundProduct {
		padding: 10px;
		cursor: pointer;

	&:hover {
		 background: #ccc;
	 }

	.productName {
		padding-right: 1rem;
		font-size: 12px;
	}

	.productPrice {
		font-size: 13px;
		width: 50%;
		display: flex;
		p {
			margin-bottom: 0;
			&:first-child {
				margin-right: .5rem;
			}
		}
	}

	.productBreadcrumb {
		font-size: 12px;
		color: #888;
	}
	}
	}
	.form-wrapper {
		position: relative;
		padding: 15px;
		border-bottom: 1px solid #e1e1e1;
		margin: 15px 0;
		border-top: 1px solid #e1e1e1;
	}

	.spinner-wrapper {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		text-align: center;
		background: rgba(0, 0, 0, 0.09);
		bottom: 0;
		z-index: 2;
		padding-top: 60px;
	}

	.generalTableClass {
		max-height: 500px;
		overflow-y: scroll;
	}
</style>
